import { Link } from '@tanstack/react-router'
import React from 'react'
import { Candidate } from '../candidate'

type UserLinkProps = {
    id: Candidate['id']
    campaignId: Candidate['campaignId']
    status: Candidate['status']
    name?: Candidate['name']
} & React.DOMAttributes<HTMLAnchorElement>

export function CandidateLink({ id, name, campaignId, children, ...rest }: UserLinkProps) {
    return (
        <Link
            to="/campaigns/$campaignId/board"
            params={{
                campaignId: campaignId,
            }}
            search={{
                candidateId: id,
            }}
            {...rest}
        >
            {name || children}
        </Link>
    )
}
